import paymentMethod from '../constants-v2/bookkeeping/payment-method';
import { EVIDENCE_TYPE_RYCZALT, EVIDENCE_VEHICLE_DEDUCTION_TYPE_EKSPLOATACJA_ID, INCOME } from '../constants/evidence.js';
import DefaultEvidenceKhEntry from './bookkeeping/evidence-kh-entry';

export default (payload = {}) => {
  return {
    evidencetype: EVIDENCE_TYPE_RYCZALT,
    evidencekind: INCOME,
    evidencekind_original: INCOME,
    vehicle: undefined,
    vehicledeductiontype: EVIDENCE_VEHICLE_DEDUCTION_TYPE_EKSPLOATACJA_ID,
    fuel_amount: '',
    proportion_rate: undefined,
    vehicle_original: '',
    external_number: '',
    document_number: '',
    counter: null,
    description: '',
    comment: '',
    is_vat_register_entered_manually: false,
    inventory_type: undefined,
    evidencekpirentry: [],
    evidenceentrykh: [DefaultEvidenceKhEntry()],
    evidencevatratevalue: [],
    _evidencevatratevalue_sum: [],
    sum_all_netto_values: 0,
    internal_evidence_counter: null,
    internal_evidence_number: null,
    has_internal_evidence: false,
    evidenceinternalevidenceentry: [],
    evidencevatregister: {
      vatregistertype: null,
      deduction_date: null,
      is_show_on_vat_ue: 0,
      is_intra_community_goods_delivery: 0,
      is_threeway_transaction: 0,
      is_supply_of_services: 0,
      is_exclude_vat: 0,
      is_intra_community_transport_means: 0,
    },
    needs_verification: false,
    issue_date: null,
    receive_date: '',
    sale_date: '',
    rate_date: null,
    payment_date: '',
    payment_deadline: '',
    entry_date: '',
    is_for_next_month: false,
    inserted_at: null,
    is_system: false,
    is_system_managed: false,
    crm: null,
    crm_original: null,
    file: null,
    invoice: null,
    invoice_original: null,
    ksef_invoice: null,
    ksef_number: '',
    ksef_identification_type: null,
    evidencevatratetype: [],
    evidencedocumenttype: {},
    evidencedocumenttype_original: null,
    evidencegtu: [],
    evidenceprocedure: [],
    currency: null,
    currency_rate: null,
    exchange_rate_evidence_id: null,
    exchange_rate_evidence_original: null,
    currency_code: null,
    evidenceentry: [],
    _evidenceentry_sum: '',
    _evidenceentry_currency_sum: '',
    _evidencekpirentry_sum: '',
    _evidencekpirentry_currency_sum: '',
    _is_belongs_to_closed_month: false,
    /**
     * Flaga wskazująca, że dane zostały załadowane z OCR
     * Używana do określenia, czy należy przeliczyć wpisy KPiR
     * dla nie-VATowców przy kosztach samochodu
     */
    _has_new_ocr_data: false,
    verification_date: null,
    verification_person: null,
    edition_date: null,
    edition_person: null,
    payment_method: paymentMethod.TRANSFER,
    ...payload,
  };
}
